<template>
    <b-card
        :title="title"
        :loading="loading"
        :error-message="errorMessage"
        @cancel="$emit('cancel')"
        @submit="mode === 1 ? create() : update()"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
    >
        <b-text-field v-model="productTag.name" :label="translations.name[lang]"></b-text-field>

        <b-text-field v-model="productTag.code" :label="translations.code[lang]"></b-text-field>
    </b-card>
</template>
 
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/products/productsTab";

export default {
    name: "ProductTagForm",

    mixins: [translations],

    props: {
        mode: Number,
    },

    computed: {
        ...mapState([
            "loading",
            "errorMessage",
            "resetSuccess",
            "resetValidation",
        ]),
        ...mapState("loyaltyPanel/productsTags", ["categories", "productTag"]),

        lang() {
            return this.$route.params.lang;
        },

        title() {
            return this.mode === 1 ? this.translations.newProductTag[this.lang] : this.translations.updateProductTag[this.lang];
        },
    },

    methods: {
        ...mapMutations(["setResetSuccess", "setResetValidation"]),
        ...mapActions("loyaltyPanel/productsTags", ["create", "update"]),
    },
};
</script>
